import { useFormContext } from 'react-hook-form';
import { SimplePanel } from '~/components/common/Panel';
import { Well } from '~/components/common/Well';
import { TextAreaInput } from '~/components/ui/forms/text-area-input';
import { TextInput } from '~/components/ui/forms/text-input';

export function VftSlideFormFields({ create }: { create: boolean }) {
  const { register } = useFormContext<Record<string, string>>();
  return (
    <SimplePanel title={create ? 'Create New Slide' : 'Update Slide'}>
      <TextInput {...register('title')} label="Title" />
      <TextAreaInput {...register('text')} label="Text" />
      {create && (
        <Well className={'text-xs'}>
          <div>Saving will save the current camera position for the slide.</div>
          <div>
            Save the slide first and select it before adding/removing SOs and
            VOMs.
          </div>
        </Well>
      )}
    </SimplePanel>
  );
}
